module.exports = "/packs/step4-sp-dca9b373f637f671b8c40541a8cbe274.png";